import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ForgetPassword } from '../../redux/Slices/AuthSlice'
import notify from '../UseNotification'
import { useNavigate } from 'react-router-dom'

const UseForgetPassword = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [email, setEmail] = useState("")
    const [loading, setLoading] = useState()
    const [isPress, setIsPress] = useState(false)
    const [isFormValid, setIsFormValid] = useState(false)
    const { forgetPassword } = useSelector(state => state.AuthReducer)

    // when change email
    const onChangeEmail = (e) => {
        localStorage.setItem("email", e.target.value)
        setEmail(e.target.value)
    }

    // validate email
    const validateEmail = (e) => {
        if (e.target.value === "") {
            notify("please, enter the email", "error")
        } else if (!e.target.value.match(emailRegex)) {
            notify("please enter correct email", "error")
        }
    }

    // to handle disable submit button
    useEffect(() => {
        if (email && email.match(emailRegex)) {
            setIsFormValid(true)
        } else {
            setIsFormValid(false)
        }
    }, [email])

    // handle submit 
    const Submit = async () => {
        setIsPress(true)
        setLoading(true)
        await dispatch(ForgetPassword({
            email
        }))
        setLoading(false)
    }

    // to handle response after dispatch the request
    useEffect(() => {
        if (loading === false) {
            setIsPress(false)
            if (forgetPassword.data) {
                if (forgetPassword.data.status === "Success") {
                    localStorage.removeItem("token")
                    notify("check your mail", "success")
                    navigate("/user/VerfiyCode")
                }
            }
            if (forgetPassword) {
                if (forgetPassword.response) {
                    localStorage.removeItem("token")
                    notify(forgetPassword.response.data.message, "error")
                }
            }

        }
    }, [loading])


    return [email, onChangeEmail, Submit, isPress, loading, validateEmail, isFormValid]
}

export default UseForgetPassword
